import { render, staticRenderFns } from "./attachmentsViewer.vue?vue&type=template&id=6b79b794"
import script from "./attachmentsViewer.vue?vue&type=script&lang=js"
export * from "./attachmentsViewer.vue?vue&type=script&lang=js"
import style0 from "./attachmentsViewer.vue?vue&type=style&index=0&id=6b79b794&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports